
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import ThoughtsCard from '../Cards/ThoughtsCard'
import LeadsList from '../Cards/LeadsList'
import RemoveAttachmentDialog from '../Dialogs/RemoveAttachmentDialog'
import AddToPLDPDialog from '../Dialogs/AddToPLDPDialog'
import Progressbar from '../ProgressBar'
import MediaPlayer from '../Dialogs/MediaPlayer'
// import CompSelect from "../categories/compSelect";
// import SubCompSelect from "../categories/subcompSelect";
import { storeSubCompetency } from '../../store/actions/subcompActions'
import { STORE_SUBCOMPETENCYID } from '../../store/actions/types'
import Typography from '@material-ui/core/Typography'
import CategoriesSelect from '../../components/categories/categoriesSelect'
import { HIDE_COMMENTS_BUTTON, ILEAD_THOUGHTS, PUBLIC_COMPANY_ID, ILEAD_BLEADS, ILEAD_LEADS2, ILEAD_LEADS3, ILEAD_LEADS4, APP_TYPE, ILEAD_THOUGHTS_REQ, ORG_THOUGHTS } from '../../store/actions/types'
import FilterListIcon from '@material-ui/icons/FilterList'
//import MenuItem from '@material-ui/core/MenuItem'
//import FormControl from '@material-ui/core/FormControl'
//import Select from '@material-ui/core/Select'
//import GlobalforumTutorial from '../../pages/PointsSurveys/GlobalforumTutorial'
import GenTutorial from '../../pages/PointsSurveys/GenTutorial'
import { MenuItem, Input, FormControl, Select, InputLabel, TextField } from '@material-ui/core';
import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import {
  isMobile,
  isBrowser
} from 'react-device-detect'
import { MDBContainer, MDBRow, MDBCol } from "mdbreact";
import { fetchThoughts, getTrendingLeads } from '../../store/actions/thoughtsActions'
import { v4 as uuidv4 } from 'uuid';
import debounce from 'lodash/debounce';

//import CategoryTabs from '../../components/categories/CategoryTabs'

const styles = (theme) => ({
  cardstyles: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    position: 'relative'
  },
  leadtrends: {
    color: "#515A5A",
    fontSize: 14,
    border: "0px",
    backgroundColor: '#F2F3F4',
    padding: 1,
    borderRadius: 2,
    align: 'left'
  },
  cleadtrends: {
    color: "#515A5A",
    fontSize: 14,
    border: "0px",
    // backgroundColor: '#F2F3F4',
    backgroundColor: '#ffffff',
    padding: 1,
    borderRadius: 2,
    align: 'left',
    marginLeft: '70px'
  },
  cats: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  filter: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'flex-start',
    alignContent: 'flex-start',
    gap: theme.spacing(1),
    marginLeft: isMobile ? '10px' : '20px'
  },
  trends: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    align: 'right',
    alignItems: 'left',
    justifyContent: 'left',
    alignContent: 'left',
    marginLeft: isMobile ? '50px' : '600px'
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    width: isMobile ? '100%' : 'auto'
  },
  selectEmpty: {
    marginRight: theme.spacing(2)
  },
  filterLabel: {
    fontSize: 12
  },
  filterTitle: {
    fontSize: 12,
    fontWeight: 600
  },
  panel: {
    'marginBottom': '10px',
    'border': '1px solid rgba(0, 0, 0, 0.12)',
    'boxShadow': 'none'
  }
})

const basiclayout = {
  color: "#515A5A",
  fontSize: 14,
  border: "0px",
  backgroundColor: '#F2F3F4',
  padding: 1,
  borderRadius: 2
}

const backGlobal = {
  marginLeft: '150px',
  color: "#656152",
  cursor: "pointer",
  hover: {
    color: "#ffffff"
  },
}

class ThoughtsView extends React.Component {
  constructor(props) {
    super(props)
    this.showLead = this.showLead.bind(this)

    if (this.props.thoughtsb && this.props.location.pathname === '/organisational') {
      this.reloadProps();
    }
    // this.handleScroll = this.handleScroll.bind(this)
    
    // Debounced author search - waits 300ms after user stops typing
    this.debouncedAuthorSearch = debounce((value) => {
      // Clear cache before updating state
      this._cachedVisibleThoughtsKey = ''
      this._cachedVisibleThoughts = []
      this.setState({ 
        authorQuery: value,
        renderLimit: 20
      }, () => {
        if (value && value.trim() !== '') {
          this.prefetchForFilter()
        }
      })
    }, 300)
  }
  //}
  state = {
    openmediaplayer: false,
    mediatype: 'podcast',
    media: null,
    openAddPLDP: false,
    attachmentType: '',
    thoughtToAdd: {},
    subcompetencyid: '',
    filter: 'none',
    fresh_thought: '',
    lthoughts: {},
    // loadThoughts: true
    orderByEngagement: false,
    authorQuery: '',
    authorInputValue: '', // Separate state for immediate input display
    dateRange: {
      startDate: null,
      endDate: null
    },
    minData: 12,
    competencyid: '',
    isFetching: false,
    filterLoading: false,  // Show loading indicator when fetching for filter
    renderLimit: 20  // Start with 20 items, load more on scroll/button
  }

  // Cache for scroll management
  _lastScrollTime = 0

  // Minimum posts to fetch for basic filters (date, author)
  FILTER_PREFETCH_MIN = 150
  
  // Higher limit for content-type filters (videos, podcasts, images, files, articles)
  // These are sparse and need more data to find enough matches
  CONTENT_FILTER_PREFETCH_MIN = 500
  
  // Maximum items to render at once to prevent DOM overload
  MAX_RENDER_ITEMS = 50

  // Cache for stability
  _lastStableThoughts = []
  _lastFilterSignature = ''
  _lastValidSource = {}  // Changed to object keyed by path
  
  // Cache for memoized visible thoughts
  _cachedVisibleThoughts = []
  _cachedVisibleThoughtsKey = ''

  // Simplified filtering and sorting with memoization
  getVisibleThoughts = () => {
    const path = (this.props.location && this.props.location.pathname) || ''
    let source = this.props.thoughtsb || this.props.thoughts

    // Update fallback source if we have valid data (path-specific)
    if (source && Object.keys(source).length > 0) {
      this._lastValidSource[path] = source
    } else if (this._lastValidSource[path]) {
      // Fallback to last valid data for THIS path if current is empty/null
      source = this._lastValidSource[path]
    }

    if (!source) return []

    // Generate cache key for memoization
    const sourceKeys = Object.keys(source)
    const cacheKey = JSON.stringify({
      f: this.state.filter,
      a: this.state.authorQuery,
      s: this.state.subcompetencyid,
      d: this.state.dateRange,
      c: this.state.competencyid,
      o: this.state.orderByEngagement,
      p: path,
      len: sourceKeys.length,
      // Include first and last IDs to detect data changes
      first: sourceKeys[0] || '',
      last: sourceKeys[sourceKeys.length - 1] || ''
    })

    // Return cached result if inputs haven't changed
    if (cacheKey === this._cachedVisibleThoughtsKey && this._cachedVisibleThoughts.length > 0) {
      return this._cachedVisibleThoughts
    }

    // Convert to array for easier handling
    let thoughtsList = sourceKeys.map(key => source[key])

// Pre-compute normalized author query once (avoid doing it per item)
const normalizedAuthorQuery = this.normalize(this.state.authorQuery)
const hasAuthorFilter = normalizedAuthorQuery && normalizedAuthorQuery !== ''
const hasSubcategoryFilter = this.state.subcompetencyid && this.state.subcompetencyid.trim() !== ''
const hasCompetencyFilter = this.state.competencyid &&
  this.normalize(this.state.competencyid) !== '' &&
  this.normalize(this.state.competencyid) !== '__all__'
const mediaFilter = this.state.filter

// Filter with optimized checks
thoughtsList = thoughtsList.filter(thought => {
  if (!thought) return false
  
  // Basic data validation - skip thoughts with missing critical data
  if (!thought.dailyThoughtID) return false
  if (!thought.title && !thought.subtitle) return false

  // Forum-level visibility (fast check first)
  try {
    const t = Number(thought?.dailyThoughtType)
    if (path === '/organisational' && !(Number.isNaN(t) || t === 1)) return false
    if (path === '/ilead' && !(t === 2 || t === 3)) return false
  } catch (e) { }

  // Date range filter
  if (!this.isWithinDateRange(thought)) return false
  
  // Media filter (only check if filter is not 'none')
  if (mediaFilter !== 'none' && !this.matchesMediaFilter(thought)) return false
  
  // Author filter (only check if query exists)
  if (hasAuthorFilter && !this.matchesAuthorFilterOptimized(thought, normalizedAuthorQuery)) return false
  
  // Competency filter (only check if a real competency is selected, no subcategory yet)
  if (hasCompetencyFilter && this.normalize(thought.competencyid) !== this.normalize(this.state.competencyid)) return false
  
  // Subcategory filter (only check if set)
  if (hasSubcategoryFilter && !this.matchesSubcategory(thought)) return false

  return true
})

    // Sort
    thoughtsList.sort((a, b) => {
      if (this.state.orderByEngagement) {
        const sb = this.getEngagementScore(b)
        const sa = this.getEngagementScore(a)
        if (sb !== sa) return sb - sa
      }
      // Default: Date descending (Newest first)
      const db = Number(b.dateScheduled || 0)
      const da = Number(a.dateScheduled || 0)
      return db - da
    })

    // --- STABILITY CHECK ---
    // Generate signature for current filter state
    const currentSignature = JSON.stringify({
      f: this.state.filter,
      a: this.state.authorQuery,
      s: this.state.subcompetencyid,
      d: this.state.dateRange,
      c: this.state.competencyid,
      o: this.state.orderByEngagement,
      p: path
    })

    if (currentSignature !== this._lastFilterSignature) {
      // Filter changed, accept new list
      this._lastFilterSignature = currentSignature
      this._lastStableThoughts = thoughtsList
    } else {
      // Filter same, check for drop
      if (thoughtsList.length < this._lastStableThoughts.length) {
        return this._lastStableThoughts
      } else {
        this._lastStableThoughts = thoughtsList
      }
    }

    // Cache the result
    this._cachedVisibleThoughtsKey = cacheKey
    this._cachedVisibleThoughts = thoughtsList

    return thoughtsList
  }
  
  // Optimized author filter that takes pre-normalized query
  matchesAuthorFilterOptimized = (thought, normalizedQuery) => {
    // Name-only search with pre-normalized query
    const nameA = this.normalize(thought.journalUserName)
    if (nameA && nameA.indexOf(normalizedQuery) !== -1) return true
    
    const first = this.normalize(thought.firstName)
    if (first && first.indexOf(normalizedQuery) !== -1) return true
    
    const last = this.normalize(thought.lastName)
    if (last && last.indexOf(normalizedQuery) !== -1) return true
    
    const full = (first && last) ? `${first} ${last}` : (first || '')
    if (full && full.indexOf(normalizedQuery) !== -1) return true
    
    const author = this.normalize(thought.author)
    if (author && author.indexOf(normalizedQuery) !== -1) return true

    return false
  }

  loadMore = () => {
    if (this.state.isFetching) return

    this.setState({
      isFetching: true,
      minData: this.state.minData + 12
    }, () => {
      this.fetchData()
    })
  }

  handleScroll = () => {
    const now = Date.now()
    if (now - this._lastScrollTime < 200) return // Simple throttle
    this._lastScrollTime = now

    const windowHeight = window.innerHeight
    const body = document.body
    const html = document.documentElement
    const docHeight = Math.max(
      body.scrollHeight, body.offsetHeight,
      html.clientHeight, html.scrollHeight, html.offsetHeight
    )
    const windowBottom = Math.round(windowHeight + window.pageYOffset)

    // Load more when near bottom (500px buffer)
    if (windowBottom >= docHeight - 500) {
      this.loadMore()
    }
  }


  // handleCompetencyChange = (event, name) => {
  //   this.setState({ competencyid: name.props.value })
  // };

  // Check if current filter is a content-type filter (sparse data)
  isContentFilter = (filter) => {
    return ['videos', 'podcasts', 'images', 'files', 'articles'].includes(filter)
  }

  handleFilterBy = (e) => {
    const newFilter = e.target.value
    this.setState({ 
      filter: newFilter,
      renderLimit: 20,  // Reset render limit when filter changes
      filterLoading: this.isContentFilter(newFilter)  // Show loading for content filters
    }, () => {
      // Clear cache immediately
      this._cachedVisibleThoughtsKey = ''
      this._cachedVisibleThoughts = []
      
      // When a filter is selected (not 'none'), pre-fetch more data to ensure we have enough results
      if (newFilter !== 'none') {
        this.prefetchForFilter(newFilter)
      }
    })
  }

  // Pre-fetch more data when filter is activated to ensure enough results
  prefetchForFilter = (filterType) => {
    // Don't fetch if already fetching
    if (this.state.isFetching) return
    
    // Determine target based on filter type
    const isContentType = this.isContentFilter(filterType || this.state.filter)
    const targetMinData = isContentType 
      ? this.CONTENT_FILTER_PREFETCH_MIN 
      : this.FILTER_PREFETCH_MIN
    
    // Clear cached results to force recomputation with new filter
    this._cachedVisibleThoughtsKey = ''
    this._cachedVisibleThoughts = []
    
    // If we already have enough data, just force update
    if (this.state.minData >= targetMinData) {
      this.setState({ filterLoading: false })
      this.forceUpdate()
      return
    }

    this.setState({
      filterLoading: true,
      minData: targetMinData
    }, () => {
      // Call parent component to increase its minData and refetch
      if (this.props.increaseMinData) {
        this.props.increaseMinData(targetMinData)
      }
      
      // Also fetch data directly
      this.fetchData()

      // Reset filterLoading after data should have arrived (longer for content filters)
      const timeout = isContentType ? 5000 : 3000
      setTimeout(() => {
        this.setState({ filterLoading: false })
      }, timeout)
    })
  }

  reloadProps = async () => {
    console.log('reloadProps called - preserving minData:', this.state.minData)
    //  this.props.thoughts = this.props.thoughtsb
    var params = {
      type: ORG_THOUGHTS,
      companyID: this.props.userdata.companyID,
      orderChild: "publish_status",
      equalTo: this.props.userdata.companyID + "_approved",
      minData: Math.max(12, this.state.minData)
    };
    await this.props.fetchThoughts(params);
  }

  componentWillReceiveProps(nextProps) {

    if (nextProps.userdata.email && this.props.userdata.email) {
      if (nextProps.userdata.email !== this.props.userdata.email) {
        // If AI Test builder is active in this tab, avoid hard reloads
        try {
          const aiActive = localStorage.getItem('AI_TEST_ACTIVE') === '1';
          if (!aiActive) {
            // Soft refresh: re-fetch data instead of reloading the whole page
            this.reloadProps();
          }
        } catch (_) {
          // Fallback to soft refresh
          this.reloadProps();
        }
        return;
      }
    }
    if (this.props !== nextProps) {
    }


    if (this.props.xthoughts) {
      this.setState({
        lthoughts: this.props.xthoughts
      })
    }

  }

  //  shouldComponentUpdate(nextProps, newState) {
  //   return this.props.thoughts.points === nextProps.thoughts.points; // use === to compare types too!
  //  }

  // handleSubCompetencyChange = (event, name) => {
  //   this.setState({ subcompetency: name.props.children })
  //   this.setState({ subcompetencyid: name.props.value })

  //   // Redux add
  //   let params = {
  //     type: STORE_SUBCOMPETENCYID,
  //     cvalue: name.props.value,
  //     scompname: name.props.children
  //   }
  //   this.props.storeSubCompetency(params)
  // };

  OpenMediaPlayer = (media, mediatype) => {
    this.setState({
      ...this.state,
      openmediaplayer: true,
      media: media,
      mediatype: mediatype
    })
  };

  CloseMediaPlayer = () => {
    this.setState({
      ...this.state,
      openmediaplayer: false,
      media: null
    })
  };

  handleOpenAddToPLDPDialog = (thought) => {
    this.setState((prevState) => ({
      openAddPLDP: true,
      thoughtToAdd: thought
    }))
  };

  getThought(props) {
    for (let x in props) {
      return props[x].subcompetencyid
      break
    }
  }

  getSubcomp = (props) => {
    for (let x in props) {
      return props[x].subcompetencyid
      // return props[x]
    }
  }

  GfetchData = () => {
    let equalTo = ''
    // CORPORATE I-LEAD
    // equalTo =
    //   APP_TYPE === 'CORPORATE'
    //     ? this.props.userdata.companyID + '_ilead_approved'
    //     : PUBLIC_COMPANY_ID + '_approved'
    var x = 12
    let params = {
      type: ILEAD_THOUGHTS_REQ,
      companyID: this.props.userdata.companyID,
      orderChild: 'publish_status',
      equalTo: PUBLIC_COMPANY_ID + '_approved',
      //this.props.userdata.companyID + "_approved",
      minData: this.state.minData //x //parseInt(12)
    }

    this.props.fetchThoughts(params)

    setTimeout(() => {
      var newThought = this.props.thoughts
      this.setState({
        lthoughts: newThought
      })
    }, 1000);
  };

  fetchData = () => {
    try {
      const path = (this.props.location && this.props.location.pathname) || ''
      if (path === '/organisational') {
        let params = {
          type: ORG_THOUGHTS,
          companyID: this.props.userdata.companyID,
          orderChild: 'publish_status',
          equalTo: this.props.userdata.companyID + '_approved',
          minData: this.state.minData
        }
        this.props.fetchThoughts(params)
      } else {
        let equalTo = ''
        equalTo =
          APP_TYPE === 'CORPORATE'
            ? this.props.userdata.companyID + '_ilead_approved'
            : PUBLIC_COMPANY_ID + '_approved'

        let params = {
          type: ILEAD_THOUGHTS_REQ,
          companyID: this.props.userdata.companyID,
          orderChild: 'publish_status',
          equalTo: equalTo,
          minData: this.state.minData
        }
        this.props.fetchThoughts(params)
      }
    } catch (e) { }
  }

  getThoughtID = (props, thoughtID) => {
    for (let x in props) {
      if (thoughtID === props[x].dailyThoughtID) {
        return x;
      }

      // return props[x].dailyThoughtID

      // return props[x]
    }
  }

  // loadLeads = () => {
  //   const promise = this.getLeads()
  //   promise.then(this.onFulfilled, this.onRejected)
  // }

  // getLeads = () => {
  //   return new Promise((resolve, reject) => {
  //     setTimeout(() => {
  //         this.props.getTrendingLeads()
  //     }, 6000)
  //   })
  // }

  showLead = (arrThoughts, opt) => {
    console.log('showLead : ', arrThoughts);
    
    // If the Test Builder is active in this tab, do not switch leads or trigger any UI changes
    try {
      const aiActive = localStorage.getItem('AI_TEST_ACTIVE') === '1'
      const testActive = localStorage.getItem('TEST_TAKING_ACTIVE') === '1'
      if (aiActive || testActive) {
        return
      }
    } catch (_) { }
    // const { thoughts } = this.props 
    var x;
    var newThought;
    var xnewThought;
    //   var keys = Object.keys(lthoughts);
    //   var keysb = keys[0];

    // if (opt) {
    //     lthoughts.points = parseInt(lthoughts.points) + parseInt(opt);
    //     lthoughts.leadPoints = parseInt(lthoughts.leadPoints) + parseInt(opt);
    //     lthoughts.countLikes= parseInt(lthoughts.countLikes) + parseInt(opt);
    //     lthoughts.Likes = {keysb : opt===1 ? true: false};
    //   }

    if (opt) { //if populated then this function is used to do actions on the LEAD
      // setTimeout(() => {
      // if(this.props.thoughts) {
      //   //do nothing
      // } else {
      let equalTo = ''
      equalTo =
        APP_TYPE === 'CORPORATE'
          ? this.props.userdata.companyID + '_ilead_approved'
          : PUBLIC_COMPANY_ID + '_approved'

      // this.loadLeads()
      // this.props.getTrendingLeads({equalTo:''})

      // let equalTo = ''
      // equalTo =
      //   APP_TYPE === 'CORPORATE'
      //     ? this.props.userdata.companyID + '_ilead_approved'
      //     : PUBLIC_COMPANY_ID + '_approved'


      //   this.loadLeads(equalTo)

      let params = {
        type: ILEAD_BLEADS, //ILEAD_LEADS4,
        // companyID: this.props.userdata.companyID,
        companyID: '-LEiZPT-C2PyLu_YLKNU',
        orderChild: 'publish_status',
        // equalTo: PUBLIC_COMPANY_ID + '_approved',
        equalTo: '-LEiZPT-C2PyLu_YLKNU_approved',
        minData: this.state.minData
      }
      //load leads data

      this.props.fetchThoughts(params)

      var lthoughts = Object.assign({}, arrThoughts)
      xnewThought = this.props.thoughts;

      if (lthoughts.dailyThoughtID && lthoughts.dailyThoughtID !== undefined) {
        x = this.getThoughtID(this.props.thoughts, lthoughts.dailyThoughtID);
      }
      else {
        x = this.getThoughtID(this.props.thoughts, lthoughts.thoughtID);
      }

      setTimeout(() => {
        let params = {
          type: ILEAD_BLEADS,
          companyID: this.props.userdata.companyID,
          orderChild: 'publish_status',
          equalTo: PUBLIC_COMPANY_ID + '_approved',
          minData: this.state.minData
          //  type: ILEAD_BLEADS,
          //  companyID: '-LEiZPT-C2PyLu_YLKNU',
          //  orderChild: 'publish_status',
          //  equalTo: '-LEiZPT-C2PyLu_YLKNU_approved',
          //  minData: this.state.minData
        }
        //load leads data
        //this.props.fetchThoughts({type: ILEAD_LEADS4})
        // this.props.fetchThoughts(params)

        //this.loadLeads(equalTo)

        newThought = this.props.thoughts[x]


        if (x) {
          this.setState({
            lthoughts: newThought
          })
        }
        else {
          this.setState({
            lthoughts: lthoughts
          })
        }

      }, 6000);
    }
    else      //JUST DISPLAY THE LEAD
    {
      this.setState({
        lthoughts: arrThoughts
      })
    }

    // let params = {
    //   type: ILEAD_BLEADS,
    //   companyID: this.props.userdata.companyID,
    //   orderChild: 'publish_status',
    //   equalTo: this.props.userdata.companyID + '_ilead_approved',
    //  // minData: this.state.minData
    // }

    // this.props.fetchThoughts(params)
    // this.setState({lthoughts: this.props.thoughts})
    //}
  }

  loadLeads = (equalTo) => {

    const promise = this.getLeads(equalTo)
    promise.then(this.onFulfilled, this.onRejected)
  }

  getLeads = (equalTo) => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        let params2 = {
          type: ILEAD_LEADS4, //ILEAD_LEADS,
          companyID: this.props.userdata.companyID,
          orderChild: 'publish_status',
          equalTo: equalTo,
          minData: this.state.minData
        }
        //this.props.getTrendingLeads(params2)
        this.props.fetchThoughts(params2)
      }, 2000)
    })
  }

  handleAddToPLDP = () => { };
  normalize = (value) => {
    if (!value) return ''
    return String(value).toLowerCase().trim()
  }
  isWithinDateRange = (thought) => {
    const { fromDate, toDate, dateRange } = this.state
    const ts = Number(thought.dateScheduled || thought.dateRegistered || thought.date || 0)

    // Quick path for predefined ranges
    if (dateRange && dateRange !== 'any') {
      const now = Date.now()
      let fromMs = 0
      if (dateRange === '7d') fromMs = now - 7 * 24 * 60 * 60 * 1000
      else if (dateRange === '30d') fromMs = now - 30 * 24 * 60 * 60 * 1000
      else if (dateRange === '365d') fromMs = now - 365 * 24 * 60 * 60 * 1000
      if (fromMs > 0) return ts >= fromMs && ts <= now
    }

    // Manual from/to fallback
    if (!fromDate && !toDate) return true
    let fromOk = true
    let toOk = true
    if (fromDate) {
      const fromTs = new Date(fromDate).getTime()
      if (!isNaN(fromTs)) fromOk = ts >= fromTs
    }
    if (toDate) {
      const toTs = new Date(toDate).getTime() + 24 * 60 * 60 * 1000 - 1
      if (!isNaN(toTs)) toOk = ts <= toTs
    }
    return fromOk && toOk
  }
  getEngagementScore = (thought) => {
    const leadPoints = Number(thought.leadPoints || 0)
    const likeCount = Number(thought.likeCount || thought.countLikes || 0)
    const likesObj = thought.Likes || thought.likes || {}
    const derivedLikes = (likesObj && typeof likesObj === 'object') ? Object.keys(likesObj).length : 0
    const commentsObj = thought.comments || {}
    const commentsCount = (commentsObj && typeof commentsObj === 'object') ? Object.keys(commentsObj).length : 0
    return leadPoints + likeCount + derivedLikes + commentsCount
  }
  // Helpers for validating media attachments
  isVideoFile = (url) => {
    const videoExtensions = ['.mp4', '.webm', '.ogg', '.mov', '.avi', '.wmv']
    if (!url || typeof url !== 'string') return false
    const u = url.toLowerCase()
    return videoExtensions.some(ext => u.includes(ext))
  }
  isYouTubeVideo = (url) => {
    if (!url || typeof url !== 'string') return false
    const u = url.toLowerCase()
    return u.includes('youtube.com') || u.includes('youtu.be')
  }
  hasValidImage = (thought) => {
    const photos = thought && thought.photos
    if (!photos || typeof photos !== 'object') return false
    try {
      const keys = Object.keys(photos)
      for (let k of keys) {
        const url = photos[k] && (photos[k].url || photos[k].thumbNailUrl)
        if (url && String(url).trim() !== '' && !this.isVideoFile(url) && !this.isYouTubeVideo(url)) return true
      }
    } catch (e) { }
    return false
  }
  hasValidVideo = (thought) => {
    if (!thought) return false
    const videos = thought.videos
    const videourl = thought.videourl
    const videosObj = thought.videosObj

    const hasInlineVideo = () => {
      if (videos && typeof videos === 'object') {
        const entries = Object.keys(videos)
        for (let key of entries) {
          const vid = videos[key]
          if (!vid) continue
          if (typeof vid === 'string' && vid.trim() !== '') return true
          if (typeof vid === 'object' && vid.url && String(vid.url).trim() !== '') return true
        }
      }
      if (typeof videos === 'string' && videos.trim() !== '') return true
      return false
    }

    const hasVideoUrlObject = () => {
      if (videourl) {
        if (typeof videourl === 'string' && videourl.trim() !== '') return true
        if (typeof videourl === 'object') {
          const value = videourl.videourl || videourl.url
          if (value && String(value).trim() !== '') return true
        }
      }
      return false
    }

    const hasVideosObjEntries = () => {
      if (!videosObj) return false
      if (Array.isArray(videosObj)) {
        return videosObj.some(item => {
          if (!item) return false
          if (typeof item === 'string') return item.trim() !== ''
          return item.url && String(item.url).trim() !== ''
        })
      }
      if (typeof videosObj === 'object') {
        const keys = Object.keys(videosObj)
        return keys.some(key => {
          const entry = videosObj[key]
          if (!entry) return false
          if (typeof entry === 'string') return entry.trim() !== ''
          return entry.url && String(entry.url).trim() !== ''
        })
      }
      if (typeof videosObj === 'string') return videosObj.trim() !== ''
      return false
    }

    if (hasInlineVideo()) return true
    if (hasVideoUrlObject()) return true
    if (hasVideosObjEntries()) return true
    if (this.hasVideoInUrls(thought)) return true
    if (this.hasVideoInFiles(thought)) return true
    return false
  }

  hasVideoInUrls = (thought) => {
    if (!thought.urls) return false
    const videoExtensions = ['.mp4', '.webm', '.ogg', '.mov', '.avi', '.wmv']
    // Ensure urls is an array before iterating
    const urls = Array.isArray(thought.urls) ? thought.urls : Object.values(thought.urls);

    for (let url of urls) {
      if (typeof url === 'string') {
        if (url.includes('youtube.com') || url.includes('youtu.be')) return true
        if (videoExtensions.some(ext => url.toLowerCase().includes(ext))) return true
      } else if (url.url && typeof url.url === 'string') {
        // Handle case where url is an object with a url property
        if (url.url.includes('youtube.com') || url.url.includes('youtu.be')) return true
        if (videoExtensions.some(ext => url.url.toLowerCase().includes(ext))) return true
      }
    }
    return false
  }

  hasVideoInFiles = (thought) => {
    const videoExtensions = ['.mp4', '.webm', '.ogg', '.mov', '.avi', '.wmv']

    if (thought.files) {
      const files = Array.isArray(thought.files) ? thought.files : Object.values(thought.files);
      for (let file of files) {
        if (file.url && typeof file.url === 'string') {
          if (videoExtensions.some(ext => file.url.toLowerCase().includes(ext))) return true
        }
      }
    }

    if (thought.fileurl) {
      const url = thought.fileurl.fileurl || thought.fileurl.url || (typeof thought.fileurl === 'string' ? thought.fileurl : '');
      if (url && typeof url === 'string') {
        if (videoExtensions.some(ext => url.toLowerCase().includes(ext))) return true
      }
    }

    return false
  }

  hasValidPodcast = (thought) => {
    if (!thought) return false
    const podcasts = thought.podcasts
    const podcasturl = thought.podcasturl
    const podcastsObj = thought.podcastsObj

    const hasPodcastEntries = () => {
      if (podcasts && typeof podcasts === 'object') {
        const keys = Object.keys(podcasts)
        return keys.some(key => {
          const pod = podcasts[key]
          if (!pod) return false
          if (typeof pod === 'string') return pod.trim() !== ''
          return pod.url && String(pod.url).trim() !== ''
        })
      }
      if (typeof podcasts === 'string') return podcasts.trim() !== ''
      return false
    }

    const hasPodcastUrl = () => {
      if (!podcasturl) return false
      if (typeof podcasturl === 'string') return podcasturl.trim() !== ''
      if (typeof podcasturl === 'object') {
        const value = podcasturl.podcasturl || podcasturl.url
        return value && String(value).trim() !== ''
      }
      return false
    }

    const hasPodcastObjEntries = () => {
      if (!podcastsObj) return false
      if (Array.isArray(podcastsObj)) {
        return podcastsObj.some(item => {
          if (!item) return false
          if (typeof item === 'string') return item.trim() !== ''
          return item.url && String(item.url).trim() !== ''
        })
      }
      if (typeof podcastsObj === 'object') {
        const keys = Object.keys(podcastsObj)
        return keys.some(key => {
          const entry = podcastsObj[key]
          if (!entry) return false
          if (typeof entry === 'string') return entry.trim() !== ''
          return entry.url && String(entry.url).trim() !== ''
        })
      }
      if (typeof podcastsObj === 'string') return podcastsObj.trim() !== ''
      return false
    }

    return hasPodcastEntries() || hasPodcastUrl() || hasPodcastObjEntries()
  }
  hasValidFile = (thought) => {
    if (!thought) return false
    const files = thought.files
    const fileurl = thought.fileurl
    const filesObj = thought.filesObj

    const hasFilesCollection = () => {
      if (files && typeof files === 'object') {
        const keys = Object.keys(files)
        return keys.some(key => {
          const file = files[key]
          if (!file) return false
          if (typeof file === 'string') return file.trim() !== ''
          if (file.url && String(file.url).trim() !== '') return true
          if (file.fileurl && String(file.fileurl).trim() !== '') return true
          return false
        })
      }
      if (typeof files === 'string') return files.trim() !== ''
      return false
    }

    const hasFileUrl = () => {
      if (!fileurl) return false
      if (typeof fileurl === 'string') return fileurl.trim() !== ''
      if (typeof fileurl === 'object') {
        const value = fileurl.fileurl || fileurl.url
        return value && String(value).trim() !== ''
      }
      return false
    }

    const hasFilesObjEntries = () => {
      if (!filesObj) return false
      if (Array.isArray(filesObj)) {
        return filesObj.some(item => {
          if (!item) return false
          if (typeof item === 'string') return item.trim() !== ''
          if (item.url && String(item.url).trim() !== '') return true
          if (item.fileurl && String(item.fileurl).trim() !== '') return true
          return false
        })
      }
      if (typeof filesObj === 'object') {
        const keys = Object.keys(filesObj)
        return keys.some(key => {
          const entry = filesObj[key]
          if (!entry) return false
          if (typeof entry === 'string') return entry.trim() !== ''
          if (entry.url && String(entry.url).trim() !== '') return true
          if (entry.fileurl && String(entry.fileurl).trim() !== '') return true
          return false
        })
      }
      if (typeof filesObj === 'string') return filesObj.trim() !== ''
      return false
    }

    return hasFilesCollection() || hasFileUrl() || hasFilesObjEntries()
  }
  hasValidArticle = (thought) => {
    if (!thought) return false
    const urls = thought.urls
    const articlesObj = thought.articlesObj
    if (urls && typeof urls === 'object' && Object.keys(urls).length > 0) return true
    if (articlesObj && typeof articlesObj === 'object' && Object.keys(articlesObj).length > 0) return true
    return false
  }
  matchesMediaFilter = (thought) => {
    const f = this.state.filter
    // console.log('Filter State:', f, 'Thought ID:', thought.dailyThoughtID)
    if (f === 'none') return true

    let result = false;
    if (f === 'videos') result = this.hasValidVideo(thought)
    else if (f === 'podcasts') result = this.hasValidPodcast(thought)
    else if (f === 'files') {
      const hasFiles = this.hasValidFile(thought)
      // console.log('Checking files for:', thought.dailyThoughtID, 'Has Files:', hasFiles, 'Files:', thought.files)
      result = hasFiles
    }
    else if (f === 'images') result = this.hasValidImage(thought)
    else if (f === 'articles') result = this.hasValidArticle(thought)
    else result = true

    if (f !== 'none' && !result) {
      // console.log(`Filter mismatch for ${f}:`, thought.dailyThoughtID, JSON.stringify(thought));
    }
    return result
  }
  matchesSubcategory = (thought) => {
    const { subcompetencyid, subcompetency, competencyid } = this.state
    if (!subcompetencyid || this.normalize(subcompetencyid) === '') return true

    const thoughtSubId = this.normalize(thought.subcompetencyid)
    const thoughtSubName = this.normalize(thought.subcompetency)

    if (thoughtSubId && this.normalize(subcompetencyid) === thoughtSubId) return true
    if (thoughtSubName && this.normalize(subcompetency) === thoughtSubName) return true

    if (this.normalize(competencyid) === '__all__') {
      const sel = this.normalize(subcompetencyid)
      const part = sel.split('-')[1] || ''
      const mapping = {
        self: ['improving self', 'lead self', 'self'],
        others: ['improving others', 'lead others', 'others'],
        organisation: ['improving organisation', 'lead organisation', 'organization', 'organisation', 'org'],
        society: ['improving society', 'improving society (community)', 'lead society', 'society', 'community']
      }

      if (part === 'silent') {
        const known = ['none', 'general', 'improving self', 'improving others', 'improving organisation', 'improving society', 'improving society (community)', 'self', 'others', 'organisation', 'society', 'community']
        if (!thoughtSubId && (!thoughtSubName || known.indexOf(thoughtSubName) === -1)) return true
        return false
      }
      if (part === 'none') {
        if (!thoughtSubId || thoughtSubId.endsWith('-none') || thoughtSubName === 'none') return true
        return false
      }
      if (part === 'general') {
        if ((thoughtSubId && thoughtSubId.endsWith('-general')) || thoughtSubName === 'general') return true
        return false
      }
      const targets = mapping[part] || []
      if (targets.length > 0) {
        if (targets.indexOf(thoughtSubName) !== -1) return true
        if (thoughtSubName) {
          for (let t of targets) { if (thoughtSubName.indexOf(t) !== -1) return true }
        }
      }
    }
    return false
  }
  matchesAuthorFilter = (thought) => {
    const q = this.normalize(this.state.authorQuery)
    if (!q || q === '') return true

    // Name-only search
    const nameA = this.normalize(thought.journalUserName)
    const first = this.normalize(thought.firstName)
    const last = this.normalize(thought.lastName)
    const full = (first && last) ? `${first} ${last}` : (first || '')
    const author = this.normalize(thought.author) // sometimes holds a name/subtitle

    if (nameA && nameA.indexOf(q) !== -1) return true
    if (first && first.indexOf(q) !== -1) return true
    if (last && last.indexOf(q) !== -1) return true
    if (full && full.indexOf(q) !== -1) return true
    if (author && author.indexOf(q) !== -1) return true

    return false
  }
  getSourceThoughts = () => {
    try {
      if (this.props.thoughtsb) return this.props.thoughtsb
      return this.props.thoughts || {}
    } catch (e) { return {} }
  }
getFilteredIds = () => {
  const source = this.getSourceThoughts() || {}
  const ids = Object.keys(source)
  const path = (this.props.location && this.props.location.pathname) || ''
  return ids.filter((id) => {
    const currentThought = source[id]
    // Route-specific visibility (mirror render logic)
    try {
      const t = Number(currentThought && currentThought.dailyThoughtType)
      if (path === '/organisational') {
        if (!(Number.isNaN(t) || t === 1)) return false
      }
      if (path === '/ilead') {
        if (!(t === 2 || t === 3)) return false
      }
    } catch (e) { }
    if (!this.isWithinDateRange(currentThought)) return false
    if (!this.matchesMediaFilter(currentThought)) return false
    if (!this.matchesAuthorFilter(currentThought)) return false

    // Competency filter (only check if a real competency is selected, no subcategory yet)
    const competencyid = this.state.competencyid
    const hasCompetencyFilter = competencyid &&
      this.normalize(competencyid) !== '' &&
      this.normalize(competencyid) !== '__all__'
    if (hasCompetencyFilter && this.normalize(currentThought.competencyid) !== this.normalize(competencyid)) return false

    if (!this.state.subcompetencyid || this.state.subcompetencyid.trim() === '') {
      // no subcategory filter
    } else {
      if (!this.matchesSubcategory || typeof this.matchesSubcategory !== 'function') {
        if ((currentThought.subcompetencyid || '').toLowerCase() !== (this.state.subcompetencyid || '').toLowerCase()) return false
      } else {
        if (!this.matchesSubcategory(currentThought)) return false
      }
    }
    return true
  })
}

  isFilterActive = () => {
    try {
      return (
        (this.state.filter && this.state.filter !== 'none') ||
        (this.state.authorQuery && String(this.state.authorQuery).trim() !== '') ||
        (this.state.subcompetencyid && String(this.state.subcompetencyid).trim() !== '') ||
        (this.state.dateRange && this.state.dateRange !== 'any')
      )
    } catch (e) { return false }
  }
  enqueueAutoLoad = () => {
    if (this._isFetching) return

    if (this.state.autoLoadTries >= this.state.maxAutoLoadTries) {
      this.setState({ autoLoading: false })
      return
    }

    this._isFetching = true
    this.setState(
      (prev) => ({
        minData: prev.minData + 12,
        autoLoadTries: prev.autoLoadTries + 1
      }),
      () => {
        this.fetchData()
        try { if (this._autoLoadTimer) clearTimeout(this._autoLoadTimer) } catch (e) { }
        this._autoLoadTimer = setTimeout(() => {
          try {
            if (!this.state.autoLoading) return
            const newCount = this.getFilteredIds().length
            if (this.state.autoLoadTries < this.state.maxAutoLoadTries && newCount <= this.state.lastAutoFilteredCount) {
              this.enqueueAutoLoad()
            }
          } catch (e) { }
        }, 800)
      }
    )
  }
  componentDidUpdate(prevProps, prevState) {
    // Reset fetching flags when data arrives
    if (this.props.thoughts !== prevProps.thoughts || this.props.thoughtsb !== prevProps.thoughtsb) {
      this.setState({ isFetching: false, filterLoading: false })
    }

    const filterChanged = (
      this.state.filter !== prevState.filter ||
      this.state.authorQuery !== prevState.authorQuery ||
      this.state.subcompetencyid !== prevState.subcompetencyid ||
      this.state.dateRange !== prevState.dateRange ||
      this.state.competencyid !== prevState.competencyid
    )

    // If filter changed or data changed, check if we need to fill the screen
    if (filterChanged || (this.props.thoughts !== prevProps.thoughts)) {
      // Reset render limit when filter changes to show fresh results quickly
      if (filterChanged && this.state.renderLimit !== 20) {
        this.setState({ renderLimit: 20 })
      }
      
      if (this.isFilterActive() && !this.state.isFetching && !this.state.filterLoading) {
        const visible = this.getVisibleThoughts()
        const isContentType = this.isContentFilter(this.state.filter)
        const targetMax = isContentType ? this.CONTENT_FILTER_PREFETCH_MIN : 200
        
        // If we have very few items and haven't reached target, load more
        if (visible.length < 12 && this.state.minData < targetMax) {
          // Increase by 100 for content filters, 50 for others
          const increment = isContentType ? 100 : 50
          const newMinData = Math.min(this.state.minData + increment, targetMax)
          if (this.props.increaseMinData) {
            this.setState({
              filterLoading: true,
              minData: newMinData
            }, () => {
              this.props.increaseMinData(newMinData)
              this.fetchData()
              setTimeout(() => {
                this.setState({ filterLoading: false })
              }, 2000)
            })
          }
        }
      }
    }
  }
  
  // Load more rendered items
  loadMoreRenderedItems = () => {
    this.setState(prev => ({
      renderLimit: prev.renderLimit + 20
    }))
  }
  
  // Handle date range change with cache clear
  handleDateRangeChange = (e) => {
    const value = e.target.value
    // Clear cache
    this._cachedVisibleThoughtsKey = ''
    this._cachedVisibleThoughts = []
    this.setState({ 
      dateRange: value,
      renderLimit: 20
    }, () => {
      if (value !== 'any') {
        this.prefetchForFilter()
      }
    })
  }
  
  // Handle engagement order change with cache clear
  handleEngagementChange = (e) => {
    const value = e.target.value === 'yes'
    // Clear cache
    this._cachedVisibleThoughtsKey = ''
    this._cachedVisibleThoughts = []
    this.setState({ 
      orderByEngagement: value,
      renderLimit: 20
    })
  }
  handleCloseDialog = () => {
    this.setState((prevState) => ({
      openAddPLDP: false,
      thoughtToAdd: {}
    }))
  };
  handleRemoveAttachement = (thought, attachmentType, attachmentID) => { };

  // function to go with CategoriesSelect ///
  handleCompState = (scname, scid, type) => {
    if (type === 'competency') {
      this.setState({ competency: scname, competencyid: scid, subcompetency: '', subcompetencyid: '' })
      return
    }
    this.setState({ subcompetency: scname, subcompetencyid: scid })
  };

  onFocus = () => {
    this.setState({
      backgroundColor: '#DEC65F'
    })
  }

  onBlur = () => {
    this.setState({
      backgroundColor: '#DEC65F'
    })
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll)
    this.fetchData()

    //  this.props.getOpinions({ //loads the opinions of leaders recorded in state
    //    type: GET_O,
    //    leaderID: this.props.userdata.userID
    //  })


    // if(this.props.xthoughts) {
    //   this.setState({
    //     lthoughts: this.props.xthoughts
    //   })
    // }
    if (this.props.xthoughts) {
      this.setState({
        lthoughts: this.props.xthoughts
      })
    }
  }

  componentWillUnmount() {
    try { window.removeEventListener('scroll', this.handleScroll) } catch (_) { }
    try { if (this._autoLoadTimer) clearTimeout(this._autoLoadTimer) } catch (_) { }
    try { if (this._autoLoadDebounce) clearTimeout(this._autoLoadDebounce) } catch (_) { }
    // Cancel debounced author search to prevent state updates after unmount
    try { if (this.debouncedAuthorSearch) this.debouncedAuthorSearch.cancel() } catch (_) { }
  }
  
  // Handle author input change - update display immediately, debounce actual filter
  handleAuthorInputChange = (e) => {
    const value = e.target.value
    // Update input display immediately for responsive feel
    this.setState({ authorInputValue: value })
    // Debounce the actual filtering
    this.debouncedAuthorSearch(value)
  }

  // shouldComponentUpdate(nextProps, nextState) {  
  //   if (this.props.thoughts !== nextProps.thoughts) {  
  //    return true;  
  //    }  
  //    return false;  
  //  } 

  // Hard-freeze global forum UI while Test Builder is active in this tab
  shouldComponentUpdate(nextProps, nextState) {
    try {
      const aiActive = localStorage.getItem('AI_TEST_ACTIVE') === '1'
      const testActive = localStorage.getItem('TEST_TAKING_ACTIVE') === '1'
      if (aiActive || testActive) {
        return false
      }
    } catch (_) { }
    return true
  }


  render() {
    const { openmediaplayer, media, mediatype, lthoughts } = this.state
    const { classes, thoughts, match, followingData, cvalue } = this.props



    var x = 0;
    let pss = false;

    if (this.props.thoughts || this.props.thoughtsb || this.props.xthoughts) {
      pss = true;
    }


    var currentThought;
    var ct = {};
    return (
      <React.Fragment>
        {isMobile ? (
          <div>
            {/* <p>&nbsp;</p> */}
          </div>
        ) : (
          <div />
        )}

        <div style={{ display: 'Block', overflowAnchor: 'auto' }}>

           {/* Categories DROPDOWN SELECT */}
          <CategoriesSelect
            keepsubcomp={false}
            doCompState={this.handleCompState}
            companyID={this.props.userdata.companyID}
            displayComp={this.props.fscompname}
            filterMode
          /> 


        </div>

        <MDBContainer style={basiclayout} >
          <MDBRow>
            <MDBCol>
              <ExpansionPanel className={classes.panel}>
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                  <FilterListIcon style={{ marginRight: '10px' }} />
                  <Typography className={classes.filterTitle}>Filters</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                  <div className={classes.filter}>
                    <GenTutorial
                      url={'https://youtu.be/bWqgnPWGt-0'}
                    />
                    <FormControl className={classes.formControl}>
                      <InputLabel id="demo-controlled-open-select-label" className={classes.filterLabel}><b>Filter by</b></InputLabel>
                      <Select
                        value={this.state.filter}
                        onChange={this.handleFilterBy}
                        displayEmpty
                        className={classes.selectEmpty}
                        inputProps={{ 'aria-label': 'Without label' }}
                      >
                        <MenuItem value={'none'}>none</MenuItem>
                        <MenuItem value={'videos'}>Videos</MenuItem>
                        <MenuItem value={'podcasts'}>Podcasts</MenuItem>
                        <MenuItem value={'files'}>Files</MenuItem>
                        <MenuItem value={'images'}>Images</MenuItem>
                        <MenuItem value={'articles'}>Articles</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl className={classes.formControl}>
                      <InputLabel id="date-range-label" className={classes.filterLabel}><b>Date range</b></InputLabel>
                      <Select
                        value={this.state.dateRange || 'any'}
                        onChange={this.handleDateRangeChange}
                        displayEmpty
                        className={classes.selectEmpty}
                        inputProps={{ 'aria-label': 'Date range' }}
                      >
                        <MenuItem value={'any'}>Any time</MenuItem>
                        <MenuItem value={'7d'}>Last 7 days</MenuItem>
                        <MenuItem value={'30d'}>Last 30 days</MenuItem>
                        <MenuItem value={'365d'}>Last year</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl className={classes.formControl}>
                      <InputLabel id="engagement-label" className={classes.filterLabel}><b>Order by engagement</b></InputLabel>
                      <Select
                        value={this.state.orderByEngagement ? 'yes' : 'no'}
                        onChange={this.handleEngagementChange}
                        displayEmpty
                        className={classes.selectEmpty}
                        inputProps={{ 'aria-label': 'Order by engagement' }}
                      >
                        <MenuItem value={'no'}>No</MenuItem>
                        <MenuItem value={'yes'}>Yes</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl className={classes.formControl}>
                      <TextField
                        label="Author (name)"
                        value={this.state.authorInputValue}
                        onChange={this.handleAuthorInputChange}
                        placeholder="e.g. Jane Smith"
                      />
                    </FormControl>
                  </div>
                </ExpansionPanelDetails>
              </ExpansionPanel>
              {(this.state.autoLoading || this.state.filterLoading) ? (
                <Typography align="center" style={{ marginTop: 8, marginBottom: 8, color: '#616161', fontSize: 13 }}>
                  {this.state.filterLoading 
                    ? (this.isContentFilter(this.state.filter) 
                        ? `Loading all ${this.state.filter}... This may take a moment.` 
                        : 'Loading posts for filter...') 
                    : 'Loading more items...'}
                </Typography>
              ) : null}

              {openmediaplayer ? (
                <MediaPlayer
                  mediatype={mediatype}
                  media={media}
                  openmediaplayer
                  CloseMedia={this.CloseMediaPlayer}
                />
              ) : null}
              <div>
                {lthoughts && typeof lthoughts.dailyThoughtID !== 'undefined' ?

                  <ThoughtsCard
                    onOpenAddToPLDPDialog={this.handleOpenAddToPLDPDialog}
                    ref={'' + lthoughts.dailyThoughtID}
                    onCommentsClick={this.handleCommentsClick}
                    thought={lthoughts}
                    showLeadb={this.showLead}
                    key={lthoughts.dailyThoughtID + 'xyx'}
                    PlayMedia={this.OpenMediaPlayer}
                    onRemoveAttachement={this.handleRemoveAttachement}
                    {...this.props}
                    following={
                      followingData
                        ? followingData[lthoughts.journalUserID]
                          ? true
                          : false
                        : false
                    }
                    hideComments={
                      this.props.userdata &&
                      HIDE_COMMENTS_BUTTON[this.props.userdata.companyID]
                    }
                    openFileViewer={this.props.openFileViewer}
                  />
                  :

                  (pss && (() => {
                    const allVisibleThoughts = this.getVisibleThoughts()
                    const limitedThoughts = allVisibleThoughts.slice(0, this.state.renderLimit)
                    const hasMore = allVisibleThoughts.length > this.state.renderLimit
                    
                    return (
                      <React.Fragment>
                        {limitedThoughts.map((currentThought, index) => {
                          if (!currentThought) return null

                          // Determine mediaFilter prop
                          let mediaFilterProp = undefined
                          if (this.state.filter === 'videos') mediaFilterProp = 'videos'
                          else if (this.state.filter === 'images') mediaFilterProp = 'images'

                          return (
                            <ThoughtsCard
                              onOpenAddToPLDPDialog={this.handleOpenAddToPLDPDialog}
                              ref={'' + currentThought.dailyThoughtID}
                              onCommentsClick={this.handleCommentsClick}
                              thought={currentThought}
                              key={currentThought.dailyThoughtID || index}
                              PlayMedia={this.OpenMediaPlayer}
                              onRemoveAttachement={this.handleRemoveAttachement}
                              mediaFilter={mediaFilterProp}
                              userdata={this.props.userdata}
                              location={this.props.location}
                              history={this.props.history}
                              match={this.props.match}
                              following={
                                followingData
                                  ? followingData[currentThought.journalUserID]
                                    ? true
                                    : false
                                  : false
                              }
                              hideComments={
                                this.props.userdata &&
                                HIDE_COMMENTS_BUTTON[this.props.userdata.companyID]
                              }
                              openFileViewer={this.props.openFileViewer}
                            />
                          )
                        })}
                        {hasMore && (
                          <div style={{ 
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '100%',
                            padding: '20px',
                            marginBottom: '20px'
                          }}>
                            <Typography 
                              style={{ 
                                marginBottom: '10px', 
                                color: '#666',
                                fontSize: '14px',
                                textAlign: 'center'
                              }}
                            >
                              Showing {limitedThoughts.length} of {allVisibleThoughts.length} items
                            </Typography>
                            <button
                              onClick={this.loadMoreRenderedItems}
                              style={{
                                padding: '10px 30px',
                                backgroundColor: '#1976d2',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer',
                                fontSize: '14px',
                                fontWeight: '500'
                              }}
                            >
                              Load More
                            </button>
                          </div>
                        )}
                      </React.Fragment>
                    )
                  })())}


                <AddToPLDPDialog
                  open={this.state.openAddPLDP}
                  onClickProceed={this.handleAddToPLDP}
                  onCloseDialog={this.handleCloseDialog}
                />
                <RemoveAttachmentDialog />
              </div>
            </MDBCol>
            <MDBCol>

              {/* { isBrowser && (this.props.location.pathname==='/' || this.props.location.pathname==='/ilead') && this.props.topleads ? 
   <div className={classes.leadtrends}>
    <br/><br/><br/><br/>
    <b><i>trending leads</i></b><br/>
       <LeadsList 
         topleads={this.props.topleads}
         showLeadb={this.showLead}
        //  loadback={this.props.location.pathname==='/' ? true:false }
       />
      </div>  
  : null } */}

              {/* <GroupsListAll
      companyID={this.props.userdata.companyID}
      userID={this.props.userdata.userID}
      userEmail={this.props.userdata.email} 
      firstName={this.props.userdata.firstName} 
      lastName={this.props.userdata.lastName}
    /> */}
            </MDBCol>
          </MDBRow>
        </MDBContainer>

      </React.Fragment>
    )
  }

}

ThoughtsView.propTypes = {
  classes: PropTypes.object.isRequired,
  thoughts: PropTypes.any
}

let ThoughtsViewStyled = withStyles(styles)(ThoughtsView)

const mapStateToProps = (state, ownProps) => ({
  followingData: state.userdata.followingButton,
  // STORE_SUBCOMPETENCYID: state.competencies.STORE_SUBCOMPETENCYID,
  subcompFilter: state.subcomp.cvalue,
  fscompname: state.scompname.scompname,
  // Prefer parent-provided thoughts (e.g., organisational), fallback to ilead slice
  thoughts: ownProps.thoughts !== undefined ? ownProps.thoughts : state.thoughts.ilead,
})

const mapDispatchToProps = (dispatch) => {
  return {
    storeSubCompetency: (params) => dispatch(storeSubCompetency(params)),
    fetchThoughts: (params) => dispatch(fetchThoughts(params)),
    getTrendingLeads: params => dispatch(getTrendingLeads(params)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ThoughtsViewStyled)
// export default (ThoughtsViewStyled)
